import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'cmv-benefit-modal',
	templateUrl: './benefit-modal.component.html',
	styleUrls: ['./benefit-modal.component.scss'],
})
export class BenefitModalComponent {
	@Input()
	title: string;
	@Input()
	message: string;
	@Input()
	image: string =
		'/assets/images/components/martha-dominguez-de-gouveia-nMyM7fxpokE-unsplash_1.png';

	constructor(private activeModal: NgbActiveModal) {}

	onAccept(): void {
		this.activeModal.close();
	}
}
